import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import "../pages-css/Chooser.css";

export default function Confirm() {
  const { param1 } = useParams();

  let data = JSON.parse(atob(param1));

  let sessionRegex = /\(([^)]+)\)/;

  let mediumRegex = /\[([^\]]+)\]/;

  let filename = data.filename.split("(")[0];
  let session = sessionRegex.exec(data.filename)[1].toLocaleUpperCase();
  let medium = mediumRegex.exec(data.filename)[1].toLocaleUpperCase();

  return (
    <>
      <div className="p-4 text-center" id="content">
        <h1 className="mb-3 p-3">
          <strong className="text-secondary">Assignment Details</strong>
        </h1>

        <table className="table table-striped">
          <tbody>
            <tr>
              <th>Subject Code</th>
              <td>{filename}</td>
            </tr>
            <tr>
              <th>Subject Name</th>
              <td>{data.subjectName}</td>
            </tr>
            <tr>
              <th>Medium</th>
              <td>{medium}</td>
            </tr>
            <tr>
              <th>Session</th>
              <td>{session}</td>
            </tr>
            <tr>
              <th>Product Price</th>
              <td>{data.price} Rs</td>
            </tr>
          </tbody>
        </table>
      </div>
      <center>
        <Link
          id="bottom-btn"
          to={"/make-payment/" + param1}
          className="btn bg-primary w-75 px-2 py-3 text-white"
        >
          <b>Confirm Details</b>
        </Link>
      </center>
    </>
  );
}
